export default class Mask {
    static decimalMask(v) {
        v=v.replace(/\D/g,"")
        v=v.replace(/(\d)(\d{1,4}$)/,"$1.$2")
        return v
    }
}